import { strings } from '../context/LanguageContext/strings'
import baseURL from '../modules/api/url'
import { ManageImports } from '../constants/ManageImports'

export const ManageStoresImports = {
    getStoresImportsFilters: () => [
        {
            placed_at: 'tableToolBar',
            type: 'string',
            key: 'store_id',
            display_name: strings.SECTION_MANAGE_STORES_IMPORTS_TABLE_STORE_ID,
            display_value: '',
            post_value: '',
            defaultDisplayValue: '',
            defaultPostValue: '',
        },
        {
            type: 'list',
            key: 'status',
            display_name: strings.STATUS,
            display_value: [],
            post_value: [],
            displayPillUtil: list => {
                const statuses = ManageImports.getStatuses()
                return list.map(item => statuses.find(s => s.value === item).display)
            },
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'action',
            display_name: strings.ACTION,
            display_value: [],
            post_value: [],
            displayPillUtil: list => {
                const actions = ManageImports.getActions()
                return list.map(item => actions.find(a => a.value === item).display)
            },
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
    ],
    getStoresImportsTableHeaders: () => [
        {
            id: 'store_id',
            label: strings.SECTION_MANAGE_STORES_IMPORTS_TABLE_STORE_ID,
            width: '20%',
            align: 'center',
        },
        {
            id: 'name',
            label: strings.SECTION_MANAGE_IMPORTS_TABLE_NAME,
            width: '20%',
        },
        {
            id: 'status',
            label: strings.STATUS,
            width: '25%',
        },
        {
            id: 'action',
            label: strings.ACTION,
            width: '20%',
        },
        {
            id: 'created_at',
            label: strings.SECTION_MANAGE_IMPORTS_TABLE_CREATE_AT,
            width: '20%',
        },
    ],
    storesImportsUrlPath: `${baseURL.SEVEN_NOW_CORE_API_URL}/store-setup/store/storeImport`,
    storesImportsSyncUrlPath: `${baseURL.SEVEN_NOW_CORE_API_URL}/store-setup/store/storeImport/sync`,
}
